import { SET_PAGE, SET_PER_PAGE, APPLY_FILTERS, RESET_FILTERS } from './action-types';

export const setPage = (page, pageParamPrefix) => ({
  type: SET_PAGE,
  payload: { page, pageParamPrefix }
});

export const setPerPage = (perPage, pageParamPrefix) => ({
  type: SET_PER_PAGE,
  payload: { perPage, pageParamPrefix }
});

export const applyFilters = (values, specialtyName) => ({
  type: APPLY_FILTERS,
  payload: { values, specialtyName }
});

export const resetFilters = (allFilters, specialtyName) => ({
  type: RESET_FILTERS,
  payload: { allFilters, specialtyName }
});
